package com.dwarshb.bms

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.*
import app.cash.sqldelight.db.SqlDriver
import org.jetbrains.compose.ui.tooling.preview.Preview

val LocalLocalization = staticCompositionLocalOf { "en" }

@Composable
@Preview
fun App(sqlDriver: SqlDriver?,deepLinkUrl: String="") {
    MaterialTheme {
//        var showContent by remember { mutableStateOf(false) }
//        Column(Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
//            Button(onClick = { showContent = !showContent }) {
//                Text("Click me!")
//            }
//            AnimatedVisibility(showContent) {
//                val greeting = remember { Greeting().greet() }
//                Column(Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
//                    Image(painterResource(Res.drawable.compose_multiplatform), null)
//                    Text("Compose: $greeting")
//                }
//            }
//        }

        TripOrganizerApp(sqlDriver, deepLinkUrl)
//        else
//            AuthenticationView(authenticationViewModel, onBackPressed = {}) {
//               firebaseUser = it
//            }

    }
}